import angular, { ILogService, IWindowService } from 'angular'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { BaseFeaturesComponent } from '../_base/base-features.component'
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'

class PrivMainComponentCtrl extends BaseFeaturesComponent {
  apptitle = 'Portal del candidato'
  menusuffix = 'C.V.'
  username = ''
  candApp = ''
  _esAdmin = false
  _enlaceNew = false

  baseUrlApiPriv = `${BASE_CANDIDATO_API}api/priv`

  constructor(private $log: ILogService, private $window: IWindowService, appConfigService: AppConfigService) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[PrivMainComponentCtrl] onInit')

    const _usercfg = this.usercfg

    this.apptitle = _usercfg.options.pageTitle
    this.menusuffix = _usercfg.options.app === 'CURR' ? 'C.V' : 'Records'
    this.username = _usercfg.username

    this._esAdmin = _usercfg.options.perfilAdmin
    this._enlaceNew = _usercfg.options.app === 'MODIFCONTRATOS'

    this.candApp = _usercfg.options.app
  }

  toggleDev() {
    $('body').toggleClass('hide__dev')
  }
}

angular.module('candidato').component('privMain', {
  bindings: {},
  controller: PrivMainComponentCtrl,
  template: require('./priv-main.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/priv-main/priv-main.component.html"
})
